var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"xs-12"},[_c('file-system-submenu',{attrs:{"bucketName":_vm.id}}),_c('core-layout-content',{attrs:{"large":""}},[_c('j-card',{staticClass:"xs-12 bg5 mb4 p4 fs3"},[_vm._v("No data here")])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }